import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { PackageOpen } from 'lucide-react';
import { useContatto } from '../../hooks/useContatto';
import { richiedeCliente } from '../../utils/contatto';

/**
 * Guardia delle pagine che chiedono un Cliente (`ROTTE_SOLO_CLIENTE` in
 * `utils/contatto.ts`). A un Contatto, che le apre da un link o dalla barra
 * degli indirizzi, mostra `DisponibileDopoPrimoOrdine` al posto della pagina,
 * le cui API risponderebbero 404 "Anagrafica cliente non collegata.". Sta nel
 * layout dell'Area Clienti, attorno all'`<Outlet />`: un controllo solo, non
 * uno per pagina.
 */
export function SoloCliente({ children }: { children: React.ReactNode }) {
  const contatto = useContatto();
  const { pathname } = useLocation();
  if (contatto && richiedeCliente(pathname)) return <DisponibileDopoPrimoOrdine />;
  return <>{children}</>;
}

/** Messaggio unico per le pagine che il Contatto ritrova dopo il primo ordine. */
export function DisponibileDopoPrimoOrdine() {
  return (
    <div className="rounded-xl border bg-white px-6 py-12 text-center" data-testid="disponibile-dopo-primo-ordine">
      <div className="w-12 h-12 rounded-full bg-[hsl(210,40%,93%)] flex items-center justify-center mx-auto mb-4">
        <PackageOpen className="w-6 h-6 text-[hsl(214,58%,41%)]" />
      </div>
      <h1 className="text-lg font-semibold mb-1">Disponibile dopo il primo ordine</h1>
      <p className="text-sm text-muted-foreground max-w-md mx-auto mb-5">
        Il tuo account cliente DTK viene aperto con il primo ordine: da quel momento trovi qui ordini, documenti e
        indirizzi di spedizione.
      </p>
      <Link
        to="/prodotti/toner"
        className="h-9 px-4 rounded-lg bg-[hsl(214,58%,41%)] text-white text-sm font-medium inline-flex items-center"
        data-testid="disponibile-dopo-primo-ordine-catalogo"
      >
        Vai al catalogo
      </Link>
    </div>
  );
}
